import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { resolveSchoolVerificationStatus } from "../utils/schoolVerification";

/** Blocks dashboard access until the platform operator approves the school. */
export default function SchoolVerificationGate({ children }) {
    const location = useLocation();
    const { currentUser } = useSelector((state) => state.user);
    const status = resolveSchoolVerificationStatus(currentUser);

    if (status === "pending") {
        if (location.pathname.startsWith("/Admin/pending-verification")) {
            return children;
        }
        return <Navigate to="/Admin/pending-verification" replace />;
    }

    if (status === "rejected") {
        return (
            <Navigate
                to="/login"
                replace
                state={{
                    message:
                        "Your school registration was not approved. Please contact platform support.",
                }}
            />
        );
    }

    return children;
}
